import {SkeletonBlock} from '@aboutyou/ui-components';
import React from 'react';
import {DESKTOP_STICKY_HEIGHT} from '../../backend-services/Header/constants';

export const NavigationTreeLoading: React.FC<{
  className?: string;
  style?: React.CSSProperties;
}> = ({className, style}) => {
  return (
    <div className={className} style={style}>
      <SkeletonBlock
        $width="100%"
        $height="22px"
        style={{marginTop: DESKTOP_STICKY_HEIGHT}}
      />
      <SkeletonBlock $width="60%" $height="18px" />
      <SkeletonBlock $width="70%" $height="18px" />
      <SkeletonBlock $width="60%" $height="18px" />
      <SkeletonBlock $width="70%" $height="18px" />
      <SkeletonBlock $width="60%" $height="18px" />
      <SkeletonBlock $width="70%" $height="18px" />
      <SkeletonBlock $width="100%" $height="22px" />
      <SkeletonBlock $width="100%" $height="22px" />
      <SkeletonBlock $width="100%" $height="22px" />
      <SkeletonBlock $width="100%" $height="22px" />
      <SkeletonBlock $width="100%" $height="22px" />
    </div>
  );
};
